import { apiClient } from './apiClient';

export class PharmacyService {
    constructor() {
        this.BASE_URL = '/pharmacies';
    }

    async getPharmacyById(id) {
        const response = await apiClient.get(`${this.BASE_URL}/${id}`);
        return response
    }
}

export const pharmacyService = new PharmacyService();